<template>
  <BaseActionModal
    :title="title"
    :confirmTitle="translatedAction"
    :loading="loading"
    :isDisabled="isDisabled"
    @cancel-click="inputVal.modal = false"
    @hidden="inputVal.modal = false"
    :isOpen="inputVal.modal"
    v-stream:ok-click="onCouponStatusUpdate"
    :okTitle="translatedAction"
    :okVariant="actionButtonVariant"
  >
    <AGCCheckboxGroup
      v-if="inputVal.action === 'BULK_ADD_CATEGORY'"
      v-model="inputVal.categoryTags"
      :options="categoryTagOptions"
      name="分類標籤"
      label="分類標籤"
      sub-label="(可選多項)"
      id="category-tags"
      :value-field="'id'"
    >
    </AGCCheckboxGroup>
    <AGCCheckboxGroup
      v-if="inputVal.action === 'BULK_REMOVE_CATEGORY'"
      v-model="inputVal.categoryTags"
      :options="categoryTagOptions"
      name="分類標籤"
      label="分類標籤"
      sub-label="(可選多項)"
      id="category-tags"
      :rules="{minTag: [selectedTagIds]}"
      :value-field="'id'"
    >
    </AGCCheckboxGroup>
    <AGCCheckboxGroup
      v-if="inputVal.action === 'BULK_ADD_CATEGORY' || inputVal.action === 'BULK_REMOVE_CATEGORY'"
      v-model="inputVal.promoTags"
      :options="promoTagOptions"
      name="推薦標籤"
      label="推薦標籤"
      sub-label="(可選多項)"
      id="promo-tags"
      :value-field="'id'"
    >
    </AGCCheckboxGroup>
    <AGCDateTimePicker
      v-if="inputVal.action === 'EDIT_PUBLISH_DUE'"
      :rules="{
        required: true,
        dateAfterMultiDates: [selectedPublishOns, true],
        dateBeforeOrEqualMultiDates: [selectedExpireDates],
      }"
      v-model="inputVal.publishDue"
      :min="null"
      :custom-messages="customMessages.publishDue"
      name="發佈結束日期"
      class="mb-3"
      has-time
      dateLabel="結束日期"
      timeLabel="結束時間"
      default-time="23:59:59"
    ></AGCDateTimePicker>
    <AGCDateTimePicker
      v-if="inputVal.action === 'EDIT_EXPIRE'"
      :rules="{ required: true, dateAfterOrEqualMultiDates: [selectedPublishDues] }"
      v-model="inputVal.expire"
      :min="null"
      :custom-messages="customMessages.expire"
      name="優惠結束日期"
      class="mb-3"
      has-time
      dateLabel="結束日期"
      timeLabel="結束時間"
      default-time="23:59:59"
    ></AGCDateTimePicker>
    <ContentEditor
      v-if="inputVal.action !== 'BULK_ADD_CATEGORY' && inputVal.action !== 'BULK_REMOVE_CATEGORY' &&
      inputVal.action !== 'EDIT_PUBLISH_DUE' && inputVal.action !== 'EDIT_EXPIRE'"
      v-model="inputVal.remarks"
      class="mb-3"
      :toolbar="remarkEditorToolbar"
      required
      :init="init"
    ></ContentEditor>
    <AGCCheckbox v-if="inputVal.action === 'APPROVE'" v-model="inputVal.doNotSendEmail">
      不要寄送電郵通知
    </AGCCheckbox>
  </BaseActionModal>
</template>

<script>
import { Subject } from 'rxjs';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import AGCCheckboxGroup from '@/components/form/AGCCheckboxGroup.vue';
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import BaseActionModal from '../BaseActionModal.vue';
import vModelMixin from '../../mixins/v-model';
import AGCCheckbox from '../form/AGCCheckbox.vue';

export default {
  mixins: [vModelMixin],
  props: {
    loading: {
      type: Boolean,
    },
    onCouponStatusUpdate: {
      type: Subject,
    },
    categoryTagOptions: {
      type: Array,
    },
    promoTagOptions: {
      type: Array,
    },
    selectedExpireDates: {
      type: Array,
      default: null,
    },
    selectedPublishOns: {
      type: Array,
      default: null,
    },
    selectedPublishDues: {
      type: Array,
      default: null,
    },
    selectedTagIds: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    remarkEditorToolbar: [
      `
      undo redo |
      bold italic underline strikethrough |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent`,
    ],
    init: {
      quickbars_insert_toolbar: false,
      height: '250',
    },
    customMessages: {
      publishDue: {
        required: '請輸入發佈時間(至)',
        dateBeforeOrEqualMultiDates: '發佈完結日期必須與優惠完結日期相同或在完結日期之前',
      },
      expire: {
        required: '請輸入優惠時間(至)',
        dateAfterOrEqualMultiDates: '優惠完結日期必須與發佈完結日期相同或在完結日期之後',
      },
    },
  }),
  components: {
    ContentEditor,
    AGCCheckboxGroup,
    BaseActionModal,
    AGCCheckbox,
    AGCDateTimePicker,
  },
  computed: {
    isDisabled() {
      const {
        remarks, action, categoryTags, promoTags, publishDue, expire,
      } = this.inputVal;
      if (this.inputVal.action === 'BULK_ADD_CATEGORY' || this.inputVal.action === 'BULK_REMOVE_CATEGORY') {
        return !(categoryTags?.length + promoTags?.length > 0);
      }
      if (this.inputVal.action === 'EDIT_PUBLISH_DUE') {
        return !publishDue;
      }
      if (this.inputVal.action === 'EDIT_EXPIRE') {
        return !expire;
      }
      if (this.$route.name === 'EditMerchant') {
        return this.loading || (!remarks && action !== 'ACTIVATE');
      }
      return action !== 'REMOVE' && (this.loading || !remarks);
    },
    title() {
      if (this.inputVal.action === 'BULK_ADD_CATEGORY') {
        return '選擇分類標籤';
      }
      if (this.inputVal.action === 'BULK_REMOVE_CATEGORY') {
        return '移除分類標籤';
      }
      if (this.inputVal.action === 'EDIT_PUBLISH_DUE') {
        return '更新發佈完結日期';
      }
      if (this.inputVal.action === 'EDIT_EXPIRE') {
        return '更新優惠完結日期';
      }
      return `確定${this.translatedAction}此${
        this.$route.name === 'EditMerchant' ? '商戶' : '優惠券'
      }？`;
    },
    translatedAction() {
      switch (this.inputVal.action) {
        case 'APPROVE':
        case 'ACTIVATE':
          return '批准';
        case 'REJECT':
          return '拒絕';
        case 'UNPUBLISH':
          return '暫停發佈';
        case 'DEACTIVATE':
          return '停用';
        case 'BULK_REMOVE_CATEGORY':
        case 'REMOVE':
          return '移除';
        default:
          return '確定';
      }
    },
    actionButtonVariant() {
      switch (this.inputVal.action) {
        case 'REJECT':
        case 'UNPUBLISH':
        case 'DEACTIVATE':
        case 'BULK_REMOVE_CATEGORY':
          return 'danger';
        case 'REMOVE':
          return 'secondary';
        default:
          return 'success';
      }
    },
  },
};
</script>
